"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaValue = schemaValue;
/**
 * Zwraca czesc schematu na podstawie sciezki
 * @param path sciezka w formacie pole.tablica[0].pole2
 */
function schemaValue(schema, path) {
    const tpath = path
        .replace(/\[/g, '.')
        .replace(/\]/g, '')
        .split('.');
    return _schemaValue(tpath, 0, schema);
}
function _schemaValue(path, pindex, schema) {
    const prop = path[pindex];
    if (prop === '') {
        if (pindex === path.length - 1) {
            return null;
        }
        else {
            return _schemaValue(path, pindex + 1, schema);
        }
    }
    if (schema.type === 'object' && schema.properties) {
        const schitem = schema.properties[prop];
        if (schitem === undefined) {
            return null;
        }
        if (pindex === path.length - 1) {
            return schitem;
        }
        else {
            return _schemaValue(path, pindex + 1, schitem);
        }
    }
    else if (schema.type === 'array' && schema.items) {
        const schitem = schema.items;
        if (schitem === undefined) {
            return null;
        }
        if (pindex === path.length - 1) {
            return schitem;
        }
        else {
            return _schemaValue(path, pindex + 1, schitem);
        }
    }
    else {
        return null;
    }
}
exports.default = schemaValue;
//# sourceMappingURL=schemaValue.js.map